// pages/settings/paytables/GlobalPayTables.js
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../utils/supabaseClient'; // Adjust path to your Supabase client setup

export default function GlobalPayTables() {
  const [payTables, setPayTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPayTables = async () => {
      try {
        const { data, error } = await supabase
          .from('pay_tables')
          .select('*')
          .order('name', { ascending: true });

        if (error) {
          throw error;
        }

        setPayTables(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPayTables();
  }, []);

  if (loading) {
    return <div className="p-4">Loading pay tables...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="p-6 bg-white min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Pay Tables</h1>
      
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-600 mb-2">All Pay Tables</h2>
        <div className="space-y-2">
          {payTables.map((table) => (
            <Link key={table.id} to={`/settings/paytables/${table.name.toLowerCase()}`}>
              <div className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
                {/* Icon - Using first letter as placeholder; customize with actual icons if available */}
                <div className="w-10 h-10 flex items-center justify-center bg-blue-100 text-blue-600 font-bold rounded-full mr-4">
                  {table.name.charAt(0).toUpperCase()}
                </div>
                <div className="flex-1">
                  <h3 className="font-medium">{table.name}</h3>
                  <p className="text-sm text-gray-500">{table.description || 'No description available'}</p>
                </div>
                {/* Badge for pay_type, similar to "Official" in the integrations page */}
                <span className="px-2 py-1 text-xs font-semibold text-orange-600 bg-orange-100 rounded-full">
                  {table.pay_type.charAt(0).toUpperCase() + table.pay_type.slice(1)}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {payTables.length === 0 && (
        <p className="text-gray-500">No pay tables found.</p>
      )}
    </div>
  );
}